module.exports = __webpack_public_path__ + "static/avis-0-baf49386d6bd0df7204168f0a8343833.jpg";